import { render, staticRenderFns } from "./lunch.vue?vue&type=template&id=db2c3420&scoped=true&"
import script from "./lunch.vue?vue&type=script&lang=ts&"
export * from "./lunch.vue?vue&type=script&lang=ts&"
import style0 from "./lunch.vue?vue&type=style&index=0&id=db2c3420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c3420",
  null
  
)

export default component.exports